import moment from 'moment';
import 'moment/locale/fr';

export { default as proRouting } from '../../../apps/pro/config/routing.yml';
export { default as frontRouting } from '../../../apps/frontend/config/routing.yml';
export { default as externalRouting } from '../../../apps/external/config/routing.yml';
export { default as apiRouting } from '../../../apps/api_oauth_v1/config/routing.yml';
export { default as guichetRouting } from '../../../apps/ticketoffice/config/routing.yml';

require('es6-promise').polyfill();

export const apiUrl = YP_CONFIG.api.url;
export const proUrl = YP_CONFIG.pro.url;
export const externalUrl = YP_CONFIG.externe.url;
export const frontUrl = YP_CONFIG.front.url;
export const guichetUrl = YP_CONFIG.guichet.url;

export function configMomentFr() {
    moment.locale('fr');
}
